import { Box, Typography } from '@mui/material';

export function NotFoundPage() {
  return (
    <Box sx={{
      p: 4
    }}>
      <Typography variant="h4" component="h1">
        404
      </Typography>
    </Box>
  );
}
